export default {
	apiKey: "AIzaSyAVAr6EJUToRLQpoy4ON1QXOiKIG_1jdEQ",
	authDomain: "emc-kr-test-t.firebaseapp.com",
	databaseURL: "https://emc-kr-test-t.firebaseio.com",
	projectId: "emc-kr-test-t",
	storageBucket: "emc-kr-test-t.appspot.com",
	messagingSenderId: "1067112698504",
	appId: "1:1067112698504:web:9682f270fcc4bce32e853d",
    measurementId: "G-YYKCJJRF05"
}